import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppcolorComponent } from './appcolor/appcolor.component';
import { CategoryPermissionComponent } from './category-permission/category-permission.component';
import { AddmenuComponent } from './menu/addmenu/addmenu.component';
import { MenulistComponent } from './menu/menulist/menulist.component';
import { AddmenuitemsComponent } from './menuitems/addmenuitems/addmenuitems.component';
import { ListmenuitemsComponent } from './menuitems/listmenuitems/listmenuitems.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { QrcommissioncategoriesComponent } from './qrcommissioncategories/qrcommissioncategories.component';
import { QrfeescategoryComponent } from './qrfeescategory/qrfeescategory.component';
import { AssistanceDirectchargePermComponent } from './assistance-directcharge-perm/assistance-directcharge-perm.component';

const routes: Routes = [
  { path: "menus", component: MenulistComponent },
  { path: "addmenu", component: AddmenuComponent },
  { path: "editmenu/:id", component: AddmenuComponent },
  { path: "menuitems", component: ListmenuitemsComponent },
  { path: "addmenuitem", component: AddmenuitemsComponent },
  { path: "editmenuitem/:id", component: AddmenuitemsComponent },
  { path: "permissions", component: PermissionsComponent },
  { path: "appColor", component: AppcolorComponent },
  { path: "qrcategory", component: QrfeescategoryComponent },
  { path: "categorypermission", component: CategoryPermissionComponent },
  { path: "assistancedirectchargepermission", component: AssistanceDirectchargePermComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemsettingsRoutingModule { }
